import React, {useContext, useEffect, useState} from "react";
import GlobalContext from "../GlobalContext";
import moment from "moment";

const EventsInfo = () => {

  const CONTEXT = useContext(GlobalContext);
  const EVENT_INFO_DATE_FORMAT = 'DD.MM.YYYY'

  function generateEventsList() {
    let eod;
    let date = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth, CONTEXT.selectedDay]).format(CONTEXT.dateFormat);

    eod = CONTEXT.events.filter(el => {
      return el.days.includes(date)
    });

    return eod;
  }

  function generateDateInfo(event) {
    let dateTxt;

    if (event.days.length === 1) {
      let date = moment(event.days[0]).format(EVENT_INFO_DATE_FORMAT);
      let weekDay = moment(event.days[0]).isoWeekday();
      dateTxt = `${CONTEXT.DAYS_TRANSLATIONS[weekDay - 1]}, ${date}`;
    } else {
      let first = moment(event.days[[0]]).format(EVENT_INFO_DATE_FORMAT);
      let last = moment(event.days[[event.days.length - 1]]).format(EVENT_INFO_DATE_FORMAT);
      dateTxt = `${first} - ${last}`;
    }

    return <span className="color-text-gray font-size-dot85rem">{dateTxt}</span>;
  }

  return (
    <div className="events-info">
      {generateEventsList().map((event, i) => {
        return <div className={"event mb-2 " + event.type + " "} key={`ei-${i}`}>
          <div className="date">
            <i className="far fa-calendar-alt color-text-orange mr-1"></i>
            {generateDateInfo(event)}
          </div>
          <h2 className="title color-text-dark font-size-1rem mb-0">
            {event.title}
          </h2>
        </div>
      })}
    </div>
  );
};

export default EventsInfo;
